import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Add, Create, FileCopySharp, Visibility } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { wsFindBy } from 'services/WService.js';
import { Toasty, useToasty } from 'hooks/Toasty';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { WithApp } from 'contexts/appContext';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { useModal } from 'hooks/useModal';
import ButtonDelete from 'hooks/ButtonDelete';
import Modal from './Modal';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 150 },
  { Header: 'Periodo', accessor: 'Periodo', width: 100 },
  { Header: 'Tipo', accessor: 'type', width: 150 },
  { Header: 'Descripción', accessor: 'description' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function ProductGroupsPanettone(props) {
  const classes = useStyles();
  const [groups, setGroups] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [dataLoading, setDataLoading] = useState(false);
  const [notify, showNotify] = useToasty();
  const [model, setOpen] = useModal();

  async function loadGroups(filter) {
    setDataLoading(true);
    let response = await wsFindBy('sale/panettone_group_products', filter);
    setDataLoading(false);
    if (response.success) setGroups(response.data);
  }

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadGroups(valueSearch)}
        />
      ) : undefined}
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Grupos de Productos Panetones{dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadGroups}
              getValueSearch={(value) => setValueSearch(value)}
              date
              dateType="month"
              labelDate="Periodo"
              dateField="Periodo"
            />
            <ReactTable
              excelName="grupos_productos_panetones"
              formatDate="DD-MM-YYYY"
              defaultWidth={1300}
              columns={columns}
              data={groups.map((item, i) => ({
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard permission={ConstantPermissions.PYMT_ACCOUNTS_SHOW}>
                      <Button justIcon round simple color={props.themeContext.buttonColorWarning}>
                        <Link to={`${item.id}`}>
                          <Visibility />
                        </Link>
                      </Button>
                    </AllowedGuard>
                    <AllowedGuard permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}>
                      <Button
                        justIcon
                        round
                        simple
                        color={props.themeContext.buttonColorWarning}
                        onClick={() => setOpen(item)}
                      >
                        <Create />
                      </Button>
                    </AllowedGuard>
                    <AllowedGuard permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_DELETED}>
                      <ButtonDelete
                        entity="sale/panettone_group_products"
                        id={item.id}
                        reload={() => {
                          setDataLoading(true);
                          loadGroups(valueSearch).then(() => setDataLoading(false));
                        }}
                      />
                    </AllowedGuard>
                  </div>
                ),
                Periodo: item.Periodo,
                type: item.type == 'O' ? 'Venta' : item.type == 'C' ? 'Cobertura' : item.type == 'I' ? 'Compra' : item.type == 'U' ? 'Unidades' : '',
                description: item.description,
                actions: '',
              }))}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
